(() => {
  const timers = new WeakMap();
  function sync(root) {
    const gallery = [...root.querySelectorAll('media-gallery')].find(item => item.getClientRects().length && item.getBoundingClientRect().width > 0);
    const product = (window._themeProducts || {})[gallery?.dataset.productId];
    if (!gallery || !gallery.slider || !product) return;
    const options = [...root.querySelectorAll('input[data-globoswatchindex]:checked')];
    const selectedId = new URL(location.href).searchParams.get('variant');
    const variant = options.length
      ? product.variants.find(item => options.every(input => item[input.dataset.globoswatchindex] === input.value))
      : product.variants.find(item => String(item.id) === selectedId) || product.selected_or_first_available_variant;
    if (variant?.featured_media) gallery.setActiveMedia(variant);
  }
  function schedule(root) {
    clearTimeout(timers.get(root));
    timers.set(root, setTimeout(() => sync(root), 100));
  }
  const roots = [...document.querySelectorAll('.m-main-product')];
  roots.forEach(root => {
    root.addEventListener('change', event => {
      if (event.target.matches('input[data-globoswatchindex], variant-picker input, variant-picker select')) schedule(root);
    }, true);
  });
  function initial() {
    roots.forEach(root => {
      schedule(root);
      setTimeout(() => sync(root), 750);
      setTimeout(() => sync(root), 2000);
    });
  }
  if (document.readyState === 'complete') initial();
  else window.addEventListener('load', initial, { once: true });
})();